// Shared helper for making a clickable <div> keyboard-accessible — a div
// with only onClick is invisible to keyboard/screen-reader users (no tab
// stop, no announced role). Pair with role="button" tabIndex={0} on the
// element: <div role="button" tabIndex={0} onClick={handler}
// onKeyDown={onEnterOrSpace(handler)}>. Production readiness audit,
// 2026-10-21 — found 34 such divs across the app with none of this.
import { useEffect } from 'react';

export function onEnterOrSpace(handler) {
  return (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handler(e);
    }
  };
}

// Escape-to-close for a modal backdrop div (onClick={onClose} on the
// backdrop already closes on an outside click/tap; this adds the
// keyboard equivalent, since the backdrop itself deliberately isn't made
// a focusable "button" — that would turn the whole screen into one
// confusing tab stop. The modal's own explicit close control still
// covers Tab+Enter.)
export function useEscapeToClose(onClose) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
}
